import { render, staticRenderFns } from "./addOrUpdateReviewa.vue?vue&type=template&id=ff3fcfd0&"
import script from "./addOrUpdateReviewa.vue?vue&type=script&lang=js&"
export * from "./addOrUpdateReviewa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports